import React from "react";
import { Box } from "@mui/material";
export default function NoRecordFounds() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
      <p>
        Your search criteria did not return any results. Please refine search
        criteria.
      </p>
    </Box>
  );
}
